/** @jsx jsx */
import styled from "styled-components"
import { jsx } from "theme-ui"
import ReactPaginate from "react-paginate"
import theme, { rem } from "@src/theme"
import CarrotLeft from "@components/assets/svg/carrotLeft.svg"
import CarrotRight from "@components/assets/svg/carrotRight.svg"

import PropTypes from "prop-types"

const Pagination = ({
  totalItemsCount,
  handlePageClick,
  pageNumber,
  ITEMS_PER_PAGE = 12,
}) => (
  <PaginateStyledWrapper>
    <ReactPaginate
      previousLabel={<CarrotLeft />}
      nextLabel={<CarrotRight />}
      breakLabel={"..."}
      forcePage={pageNumber}
      pageCount={Math.ceil(totalItemsCount / ITEMS_PER_PAGE)}
      marginPagesDisplayed={2}
      pageRangeDisplayed={5}
      onPageChange={handlePageClick}
      containerClassName={"pagination"}
      subContainerClassName={"pages pagination"}
      activeClassName={"active"}
    />
  </PaginateStyledWrapper>
)

Pagination.propTypes = {
  totalItemsCount: PropTypes.number,
  handlePageClick: PropTypes.func,
  pageNumber: PropTypes.number,
  ITEMS_PER_PAGE: PropTypes.number,
}

export default Pagination

const PaginateStyledWrapper = styled.div`
  font-family: ${theme.fonts.heading};
  width: 100%;
  max-width: ${rem(262)};
  margin: ${`${rem(70)} auto 0 auto`};
  .active {
    color: white;
    background: ${theme.colors.darkPurple};
    padding: 4px 8px 4px 8px;
  }

  .pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    list-style: none;
    li {
      cursor: pointer;
      &:hover:not(.active) {
        svg {
          fill: ${theme.colors.purple};
          color: ${theme.colors.purple};
        }
        color: ${theme.colors.purple};
      }
    }
  }
`
